export const SLIDER_TAG_NAME = "slider" as const;

export const THUMB_SIZE = 16;

export const TRACK_SIZE = 4;

export const SLIDER_MIN_LENGTH = 120;

export const SLIDER_TOOLTIP_VISIBILITIES = ["auto", "always", "never"] as const;
